import { render, staticRenderFns } from "./RootPage.vue?vue&type=template&id=317b6df2&scoped=true&"
var script = {}
import style0 from "./RootPage.vue?vue&type=style&index=0&id=317b6df2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317b6df2",
  null
  
)

export default component.exports